import { useAppDispatch } from 'src/services/redux/app/Store';
import { setMerchantTemplateIdReducer, setTemplateNumberReducer, setNewTemplateReducer } from 'src/services/redux/slices/template/template-slice';
import { useActionTemplate, useCopyTemplate, useGetActiveTemplate } from '../../services';

type ActiveTemplateType = {
  data: [] | any;
};
export default function ActiveTemplate(props: ActiveTemplateType) {
  const { data } = props;
  const dispatch = useAppDispatch();
  const { mutateAsync: actionTemplate } = useActionTemplate();
  const { refetch: activeTemplate } = useGetActiveTemplate();
  const { mutateAsync: copyTemplate } = useCopyTemplate();

  const templateDelete = async (templateId: number) => {
    const response: any = await actionTemplate({
      payload: {
        state: 'deleted',
      },
      schema: String(templateId),
    });
    response?.template?.status === 200 && activeTemplate();
    dispatch(setMerchantTemplateIdReducer(templateId - 1));
  };

  const selectTemplate = (templateId: number, id: number) => {
    dispatch(setTemplateNumberReducer(templateId));
    dispatch(setMerchantTemplateIdReducer(id));
  };

  const newTemplate = () => {
    dispatch(setNewTemplateReducer(true));
  };

  const copyNewTemplate = async (schemaId: number) => {
    await copyTemplate({
      schema: String(schemaId),
    });
  };

  const stateName = (state: string) => {
    switch (state) {
      case 'draft':
        return 'Taslak';
      case 'waiting':
        return 'İnceleme Bekliyor';
      case 'in_progress':
        return 'İncelemede';
      case 'approved':
        return 'Onaylandı';
      case 'rejected':
        return 'Reddedildi';
      case 'archived':
        return 'Arşivlendi';
      case 'published':
        return 'Yayında';
      case 'blocked':
        return 'Engellendi';
      case 'deleted':
        return 'Silindi';
      default:
        return 'Bilinmiyor';
    }
  };

  return (
    <div className="d-flex w-full flex-column gap-4">
      <div className="d-flex gap-6 align-items-center justify-content-between">
        <strong className="fs-2">Mevcut Şablon</strong>
        <button className="btn btn-success w-200px" onClick={() => newTemplate()}>
          Yeni Şablon Oluştur
        </button>
      </div>
      <div className="d-flex gap-6 align-items-center flex-wrap">
        {data.map((item: any) => (
          <div
            className={`d-flex gap-6 border border-3  pe-4 ${
              item.state === 'rejected' ? 'bg-danger bg-opacity-20' : item.state === 'published' ? 'bg-success bg-opacity-20' : 'bg-white'
            }`}
            style={{ width: '49%' }}
            key={item.id}
          >
            <div className="d-flex h-300px w-50 bg-secondary align-items-center justify-content-center">
              <img src={item.thumbnail} alt="template" className="rounded" height={275} />
            </div>
            <div className="d-flex flex-column gap-4 justify-content-center fs-4">
              <div className="d-flex gap-2">
                <strong>Şablon Adı:</strong>
                <div>{item.name}</div>
              </div>
              <div className="d-flex gap-2">
                <strong>Oluşturulma Tarihi:</strong>
                <div>{item.createdAt}</div>
              </div>
              <div className="d-flex gap-2">
                <strong>Durum:</strong>
                <div>{stateName(item.state)}</div>
              </div>
              {item.state === 'rejected' && (
                <div className="d-flex gap-2 bg-danger rounded p-2 text-white">
                  <strong>Reddetme Nedeni:</strong>
                  <div>{item?.logDetail?.reasonVal}</div>
                </div>
              )}
              <div className="d-flex gap-5">
                {item.state === 'approved' || item.state === 'archived' || item.state === 'published' || item.state === 'blocked' ? (
                  <button className="btn btn-primary w-200px" onClick={() => copyNewTemplate(item.id)}>
                    Kopyala
                  </button>
                ) : (
                  <button className="btn btn-primary w-200px" disabled={item.state === 'in_progress'} onClick={() => selectTemplate(item.templateId, item.id)}>
                    Taslağı Düzenle
                  </button>
                )}
                <button className="btn btn-danger w-200px" onClick={() => templateDelete(item.id)}>
                  Taslağı Sil
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
